import {Component, ViewChild} from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';

import {SelectItem} from 'primeng/api';

@Component({ standalone: false,
    selector: 'dux-dropdownFilter-editor',
    template: `<div><p-multiSelect [options]="inputvalues" [(ngModel)]="selectedvalues" [panelStyle]="{minWidth:'6em'}" (onChange)="onChange($event)"></p-multiSelect>
    </div><div><button pButton type="button" label="Clear" class="ui-button-rounded ui-button-secondary" ></button>
    <button pButton type="button" label="Apply" class="ui-button-rounded ui-button-success" ></button></div>
    `
})
export class DropdownFilterEditorComponent implements ICellEditorAngularComp {
    params: any;
    value: any;
    inputvalues: SelectItem [] = [];
    selectedvalues: string[] = [];
    @ViewChild('dropdown') dropdown: any;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.defaultValue;

        for (let i = 0; i < this.params.values.length; i++) {
                this.value = this.params.values[i];
                this.inputvalues.push({label: this.params.values[i], value: this.params.values[i]});
            this.selectedvalues.push(this.params.values[i]);
        }
    }

    getValue(): any {
        window.setTimeout(() => {
            const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
            this.params.context.componentParent.updateRow(rowIndex);
        },0);

        return this.value.id;
    }

    onChange(newValue: any) {
        this.value = newValue;
        this.params.api.stopEditing();
    }

    isPopup() {
        return true;
    }
}
